import { CircleLayer, SymbolLayer } from 'react-map-gl';
import { MAPBOX_CONFIG } from '~/constants/mapbox';

const { POINT_MIN_ZOOM, CLUSTER_MAX_ZOOM } = MAPBOX_CONFIG;

// Normal Layers
export const getLayer = (
  id: string,
  source: string,
  iconImage = 'marker-offmarket'
) => {
  return {
    minzoom: POINT_MIN_ZOOM,
    type: 'symbol',
    id,
    source,
    layout: {
      'icon-image': iconImage,
      'icon-allow-overlap': true, // Set to true to improve render speed
      'icon-size': {
        stops: [
          [8, 0.15],
          [12, 0.3],
          [14, 0.4],
          [16, 0.6],
          [20, 0.8],
        ],
      },
    },
    // paint: {
    //   'circle-color': circleColor,
    //   'circle-radius': {
    //     stops: [
    //       [8, 2],
    //       [12, 4],
    //       [14, 7],
    //       [16, 9],
    //       [20, 18],
    //     ],
    //   },
    // },
    // filter: ['==', ['get', 'status'], 'offmarket'],
    // layout: {
    //   ...sharedLayerProperties.layout,
    //   'icon-image': 'marker-offmarket',
    // },
  } as SymbolLayer;
};

// filter: ['==', ['get', 'status'], 'notClaimed'],
// layout: {
//   ...sharedLayerProperties.layout,
//   'icon-image': 'marker-notClaimed',
// },

// Cluster Layers

export const getClusterLayer = (
  id: string,
  source: string,
  circleColor: string
) => {
  return {
    maxzoom: CLUSTER_MAX_ZOOM,
    id,
    source,
    type: 'circle',
    paint: {
      'circle-color': circleColor,
      'circle-radius': [
        'step',
        ['get', 'point_count'],
        20,
        100,
        30,
        750,
        40,
      ] as TODO,
      // 'circle-color': [
      //   'step',
      //   ['get', 'point_count'],
      //   STATUSES.offmarket.color,
      //   100,
      //   STATUSES.offmarket.color,
      //   750,
      //   STATUSES.offmarket.color,
      // ],
    },
  } as CircleLayer;
};

// Cluster Count Layers

export const getClusterCountLayer = (id: string, source: string) => {
  return {
    maxzoom: CLUSTER_MAX_ZOOM,
    type: 'symbol',
    id,
    source,
    layout: {
      'text-allow-overlap': false, // Set to true to improve render speed
      'text-field': '{point_count_abbreviated}',
      'text-font': ['Gilroy'],
      'text-size': 72, // FIXME: Should be 12, once resolution bug is fixed
    },
  } as SymbolLayer;
};

export const getFillLayer = (
  id: string,
  source: string,
  color: string
): TODO => ({
  id,
  type: 'fill',
  source,
  paint: {
    'fill-color': color,
    'fill-opacity': 0.1,
  },
});

export const getLineLayer = (
  id: string,
  source: string,
  color: string,
  width: number
): TODO => ({
  id,
  type: 'line',
  source,
  paint: {
    'line-color': color,
    'line-width': width,
  },
});
